import React from 'react';
import { Clock, Mail, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PendingApproval: React.FC = () => {
    const navigate = useNavigate();
    const { logout } = useAuth();

    const handleLogout = () => {
        logout(); // Use AuthContext logout to properly clear state
        navigate('/login');
    };

    return (
        <div className="min-h-screen bg-background-dark flex items-center justify-center p-4">
            <div className="max-w-2xl w-full">
                <div className="bg-surface-dark border border-slate-800 rounded-2xl p-8 md:p-12">
                    {/* Icon */}
                    <div className="flex justify-center mb-6">
                        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-amber-900/30 border border-amber-800">
                            <Clock className="w-10 h-10 text-amber-400" />
                        </div>
                    </div>

                    {/* Title */}
                    <h1 className="text-3xl font-bold text-white text-center mb-4">
                        Cuenta Pendiente de Aprobación
                    </h1>

                    {/* Description */}
                    <p className="text-slate-400 text-center text-lg mb-8">
                        Tu cuenta ha sido creada exitosamente, pero necesita ser aprobada por un administrador antes de que puedas acceder al sistema.
                    </p>

                    {/* Info Box */}
                    <div className="bg-slate-900/50 border border-slate-800 rounded-xl p-6 mb-8">
                        <h2 className="text-white font-semibold mb-3 flex items-center gap-2">
                            <Mail className="w-5 h-5 text-primary" />
                            ¿Qué sigue?
                        </h2>
                        <ul className="space-y-3 text-slate-400">
                            <li className="flex items-start gap-2">
                                <span className="text-primary mt-1">•</span>
                                <span>Un administrador del sistema revisará tu solicitud de acceso</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-primary mt-1">•</span>
                                <span>Recibirás un correo electrónico cuando tu cuenta sea aprobada</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-primary mt-1">•</span>
                                <span>Una vez aprobada, podrás acceder a todas las funciones del sistema</span>
                            </li>
                        </ul>
                    </div>

                    {/* Status */}
                    <div className="bg-amber-900/20 border border-amber-800/50 rounded-lg p-4 mb-6">
                        <p className="text-amber-400 text-sm text-center">
                            <strong>Estado actual:</strong> Pendiente de aprobación
                        </p>
                    </div>

                    {/* Actions */}
                    <div className="flex flex-col sm:flex-row gap-3 justify-center">
                        <button
                            onClick={handleLogout}
                            className="flex items-center justify-center gap-2 px-6 py-3 bg-slate-800 hover:bg-slate-700 text-white rounded-lg transition-colors"
                        >
                            <LogOut className="w-5 h-5" />
                            Cerrar Sesión
                        </button>
                    </div>

                    {/* Footer */}
                    <p className="text-slate-500 text-sm text-center mt-8">
                        ¿Necesitas ayuda? Contacta al administrador del sistema.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PendingApproval;
